import styled from "styled-components";
import { Token } from "@sablier/v2-components/molecules";
import { _ } from "@sablier/v2-mixins";
import type { ComponentProps } from "react";

const Wrapper = styled.div`
  ${(props) => props.theme.styles.row}
  & {
    height: 52px;
    padding: 0 12px;
    border: 2px solid ${(props) => props.theme.colors.dark400};
    border-radius: 6px;
    cursor: pointer;

    &:hover,
    &:active {
      &:not([data-active="true"]) {
        background-color: ${(props) => props.theme.colors.dark300};
      }
    }

    &[data-active="true"] {
      border: 2px solid ${(props) => props.theme.colors.dark700};
      background-color: ${(props) => props.theme.colors.dark300};
      cursor: default;
    }
  }
`;

interface Props {
  image?: ComponentProps<typeof Token>["image"];
  isActive?: boolean;
  onClick: () => void;
  title: string;
}

function Chip({ title, image, isActive = false, onClick }: Props) {
  return (
    <Wrapper data-active={isActive} onClick={onClick}>
      <Token empty={"dark400"} image={image} symbol={title} />
    </Wrapper>
  );
}

export default Chip;
